import React, { useState } from "react";
import CreateSubCategoryForm from "./form";

const CreateFastener = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    subcategory_image: "",
    fastener_category_id: "",
    application_area__id: "",
    category_id: "",
  });

  return (
    <>
      <CreateSubCategoryForm data={formData} />
    </>
  );
};

export default CreateFastener;
